import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import env from '../../config/env';
import { getReviewHighlights } from '../../api/real/reviewsApi';
import { sourceText } from './reviewSource';

const MIN_TO_SHOW = 3;

/** Home page: real approved 4–5★ customer reviews. Hidden until the store shows reviews and has at least three. */
const ReviewHighlights = ({ renderSection }) => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    if (env.isMock) return undefined;
    let alive = true;
    getReviewHighlights(8)
      .then((d) => { if (alive && d?.textPublic) setReviews(d.reviews || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (reviews.length < MIN_TO_SHOW) return null;
  const cards = reviews.slice(0, 4).map((t) => (
    <div key={t.id} className="bg-white/10 border border-white/20 rounded-xl p-5 hover:bg-white/15 transition-all">
      <div className="flex gap-0.5 mb-3" aria-label={`${t.rating} out of 5 stars`}>
        {Array.from({ length: t.rating }).map((_, j) => <span key={j} className="text-amber-400 text-sm">★</span>)}
      </div>
      <p className="text-white/85 text-sm leading-relaxed mb-4 line-clamp-6">"{t.body}"</p>
      <div className="flex items-center gap-2.5 border-t border-white/15 pt-3">
        <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-white font-bold text-sm shrink-0">
          {t.authorName?.[0] || '★'}
        </div>
        <div className="min-w-0">
          <p className="text-white font-semibold text-xs">{t.authorName}{t.authorLocation ? `, ${t.authorLocation}` : ''}</p>
          <p className="text-white/50 text-xs truncate">
            {sourceText(t)}{t.productHandle ? <> · <Link to={`/product/${t.productHandle}`} className="hover:text-white">{t.productTitle}</Link></> : null}
          </p>
        </div>
      </div>
    </div>
  ));
  return renderSection(cards);
};

export default ReviewHighlights;
